import React, {ReactElement} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import TooltipWrapper from '../../ui/components/common/TooltipWrapper';
import {setDesktopViewSelected} from '../../store/actions/layout.actions';
import {desktopViewSelector} from '../../store/selectors/layout.selectors';
import IconButton from '../../incase-domain/components/iconButton/IconButton';

function ToggleMobileView(): ReactElement {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const isDesktopViewSelected = useSelector(desktopViewSelector);

    function toggleMobileView(): void {
        dispatch(setDesktopViewSelected(!isDesktopViewSelected));
    }

    return (
        <TooltipWrapper
            id="toggleMobile"
            className="c-toggleMobile"
            content={<>{isDesktopViewSelected ? t('footer.toggleMobileView') : t('footer.toggleDesktopView')}</>}
        >
            <IconButton
                icon={isDesktopViewSelected ? 'fa-solid:mobile-alt' : 'fa:desktop'}
                label={t(isDesktopViewSelected ? 'header.mobileView' : 'header.desktopView')}
                onClick={toggleMobileView}
            />
        </TooltipWrapper>
    );
}

export default ToggleMobileView;
